import { createContext, type Context } from 'react';

import { type UIConfig } from '../../../types';
import { initialState } from './initialState';

export const uiConfig: Context<UIConfig> = createContext<UIConfig>(initialState);
